/**
 * Material-UI styling configuration for company management table components.
 *
 * @module components/admin/CompanyTable
 * @author Snowfly
 * @version 1.0.0
 */

/**
 * Generates the styling configuration for the CompanyTable component.
 *
 * @param {Object} theme - The Material-UI theme object.
 * @returns {Object} An object containing class style definitions for the
 *      CompanyTable component.
 */
export const CompanyTable = (/* theme */) => ({
    root: {
        width: '100%',
        height: '100%',
    },
    thead: {
        backgroundColor: '#e1e1e1',
        '& .MuiTableCell-head': {
            paddingTop: '1em',
            paddingBottom: '1em',
        },
    },
    heading: {
        fontWeight: '600',
        fontSize: '0.9em',
    },
    headingAuto: {
        fontWeight: '600',
        fontSize: '0.9em',
        width: '100%',
    },
    actions: {
        minWidth: '8em !important',
    },
    bold: {
        fontWeight: 'bold',
        fontSize: '0.9em',
    },
    built: {
        fontSize: '0.9em',
        display: 'flex',
        justifyContent: 'left',
    },
    permissionsTableCell: {
        paddingLeft: '3em',
        color: '#B88495',
        textDecoration: 'underline',
        fontWeight: '600',
        fontSize: '0.9em',
    },
    firstNameCell: {
        paddingTop: '1em',
    },
    lastNameCell: {
        fontSize: '0.9em',
    },
    emailIdCell: {
        fontSize: '0.9em',
    },
    roleCell: {
        fontSize: '0.9em',
    },
    groupCell: {
        textDecoration: 'underline',
        fontSize: '0.9em',
    },
    statusCell: {
        fontSize: '0.9em',
    },
    addIcon: {
        marginLeft: '1em',
        minWidth: '0vw',
        backgroundColor: '#882647',
        color: '#fff',
        width: '1.3vw',
        height: '1.1vw',
    },
    titleCell: {
        fontSize: '0.9em',
    },
    phoneNumberCell: {
        fontSize: '0.9em',
    },
    small: {
        width: '2em',
        height: '2em',
    },
    no_of_members: {
        paddingRight: '6em',
    },
    companyImageField: {
        position: 'relative',
        display: 'inline-flex',
        gap: '1em',
        alignContent: 'center',
        alignItems: 'center',

        '& image': {
            position: 'relative',
            zIndex: 0,
            isolation: 'isolate',
        }
    },
    logoCloser: {
        position: 'absolute',
        left: 0,
        top: 0,
        width: '100%',
        height: '100%',
        cursor: 'pointer',
        zIndex: 1,
        isolation: 'isolate',

        '&:hover': {
            backgroundColor: 'rgba(255, 255, 255, 0.5)',
        },
    },
    closeIcon: {
        display: 'none',
    },
    closeIconHover: {
        position: 'absolute',
        left: 'calc(50% - 0.5em)',
        top: 'calc(50% - 0.5em)',
        borderRadius: 15,
        border: '2px solid #cc6487',
        padding: 1,
        color: '#882e47',
        cursor: 'pointer',
        backgroundColor: 'white',
        fontSize: '2rem',
        display: 'block',
    },
    buttonSqr: {
        padding: '5px',
        marginRight: '5px',
        minHeight: 0,
        minWidth: 0,
        cursor: 'pointer',
    },
    buttonDelete: {
        padding: '5px',
        marginRight: '5px',
        minHeight: 0,
        minWidth: 0,
        background: '#DC004E',
        color: '#fff',
        cursor: 'pointer',
    },
    editIcon: {
        padding: '5px',
        marginRight: '5px',
        minHeight: 0,
        minWidth: 0,
        color: '#fff',
        backgroundColor: '#882647',
        cursor: 'pointer',
    },
    addButton: {
        fontSize: 12,
        whiteSpace: 'nowrap',
        height: 34,
    },
});

export default CompanyTable;
